<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title class="redColor d-flex text-white">
        <span class="headline">{{ $t("vehicle_entry.selected_parts") }}</span>
        <v-spacer />
        <v-btn variant="outlined" icon color="white" @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row class="mt-3">
          <!---------------------------------------- LIST ----------------------------------------->
          <v-col
            v-for="item in items"
            :key="item._id"
            cols="12"
          >
            <v-divider />

            <v-row class="justify-center pt-3 ml-1">
              <v-col cols="12" sm="6" md="6" lg="6" class="pa-1">
                <div class="caption">
                  {{ $t("vehicle_entry.title") }}
                </div>
                <div class="subheading">
                  {{ item.title[$store.getters.language] }}
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" class="pa-1 d-flex">
                <div class="caption">
                  {{ $t("vehicle_entry.selected") }}
                </div>
                <div class="subheading">
                  <v-icon v-if="item.selected" color="red-darken-1">
                    mdi-checkbox-marked-outline
                  </v-icon>
                  <v-icon v-else color="red-darken-1">
                    mdi-checkbox-blank-outline
                  </v-icon>
                </div>
              </v-col>

              <v-col cols="12" sm="4" md="4">
                <div class="caption">
                  {{ $t("vehicle_entry.notes") }}
                </div>
                <div class="font-weight-bold">
                  {{ item.notes }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="mt-2">
          <v-col cols="12">
            <v-textarea
              :label="$t('vehicle_entry.comment')"
              disabled
              :value="comment"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    loading: false,
    position: null,
    comment: null,
    items: [],
  }),
  watch: {
    dialog(value) {
      if (!value) {
        this.close();
      }
    },
  },
  methods: {
    open(position, items, comment) {
      this.dialog = true;
      this.position = position;
      this.comment = comment;
      this.items = items || [];
    },
    close() {
      this.dialog = false;
      this.position = null;
      this.comment = null;
      this.items = [];
      this.$emit("close");
    },
  },
};
</script>
